export default "__VITE_ASSET__CflVXbAS__"